import React from 'react';

class FormSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: [],
      isValid: false
    };
  }

  validate() {
    // Override in child classes
    return [];
  }

  clearError(fieldName) {
    if (this.props.clearErrors) {
      this.props.clearErrors(fieldName);
    }
  }

  handleInputChange = (fieldName, value) => {
    if (this.props.setValue) {
      this.props.setValue(fieldName, value);
    }
    this.clearError(fieldName);
  };

  renderField(config) {
    const { register, errors, watch } = this.props;
    const { name, label, type = 'text', required = false, validation = {}, placeholder = '', options = [] } = config;

    const error = errors[name];
    const watchedValue = watch ? watch(name) : undefined;

    const inputClasses = `mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm ${
      error ? 'border-red-500' : ''
    }`;

    const labelClasses = `block text-sm font-medium text-gray-700 ${required ? 'required' : ''}`;

    return (
      <div key={name} className="mb-4">
        <label htmlFor={name} className={labelClasses}>
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
        
        {type === 'text' && (
          <input
            {...register(name, { required: required ? `${label} is required` : false, ...validation })}
            type="text"
            id={name}
            placeholder={placeholder}
            className={inputClasses}
            onChange={(e) => this.handleInputChange(name, e.target.value)}
          />
        )}

        {type === 'textarea' && (
          <textarea
            {...register(name, { required: required ? `${label} is required` : false, ...validation })}
            id={name}
            placeholder={placeholder}
            rows={4}
            className={inputClasses}
            onChange={(e) => this.handleInputChange(name, e.target.value)}
          />
        )}

        {type === 'select' && (
          <select
            {...register(name, { required: required ? `${label} is required` : false, ...validation })}
            id={name}
            className={inputClasses}
            onChange={(e) => this.handleInputChange(name, e.target.value)}
          >
            <option value="">Select...</option>
            {options.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        )}

        {type === 'radio' && (
          <div className="mt-2 space-y-2">
            {options.map(option => (
              <label key={option.value} className="flex items-center">
                <input
                  {...register(name, { required: required ? `${label} is required` : false, ...validation })}
                  type="radio"
                  value={option.value}
                  className="mr-2"
                  onChange={(e) => this.handleInputChange(name, e.target.value)}
                />
                <span className="text-sm text-gray-700">{option.label}</span>
              </label>
            ))}
          </div>
        )}

        {type === 'checkbox' && (
          <div className="mt-2 space-y-2">
            {options.map(option => (
              <label key={option.value} className="flex items-center">
                <input
                  {...register(name, { required: required ? `${label} is required` : false, ...validation })}
                  type="checkbox"
                  value={option.value}
                  className="mr-2"
                  onChange={(e) => this.handleInputChange(name, e.target.checked ? option.value : '')}
                />
                <span className="text-sm text-gray-700">{option.label}</span>
              </label>
            ))}
          </div>
        )}

        {type === 'url' && (
          <input
            {...register(name, { 
              required: required ? `${label} is required` : false,
              pattern: {
                value: /^https?:\/\/.+/,
                message: 'Please enter a valid URL starting with http:// or https://'
              },
              ...validation 
            })}
            type="url"
            id={name}
            placeholder={placeholder}
            className={inputClasses}
            onChange={(e) => this.handleInputChange(name, e.target.value)}
          />
        )}

        {error && (
          <p className="mt-1 text-sm text-red-600">{error.message}</p>
        )}
      </div>
    );
  }

  renderConditionalField(condition, config) {
    const { watch } = this.props;
    const watchedValue = watch ? watch(condition.field) : undefined;
    
    if (condition.equals && watchedValue === condition.equals) {
      return this.renderField(config);
    }
    
    if (condition.includes && condition.includes.includes(watchedValue)) {
      return this.renderField(config);
    }
    
    return null;
  }

  renderSectionHeader(title, subtitle = '') {
    return (
      <div className="mb-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-2">{title}</h2>
        {subtitle && <p className="text-gray-600">{subtitle}</p>}
      </div>
    );
  }

  render() {
    // Override in child classes
    return null;
  }
}

export default FormSection;